/** Contenu francais, la reference. */
import type { LanguageContent } from '../registry.js';
import { HOME_FAQ, HOME_INTRO, HOME_MODES, HOME_STEPS } from './home.js';
import { HOW_TO_PLAY } from './howToPlay.js';
import { MODES, MODES_PREMIUM, MODE_TABLE } from './modes.js';
import { ARTICLES } from './blog.js';

export const FR: LanguageContent = {
  home: {
    intro: HOME_INTRO,
    steps: HOME_STEPS,
    modes: HOME_MODES,
    faq: HOME_FAQ,
    headings: {
      intro: 'Un jeu de dessin où il faut disparaître',
      steps: 'Comment jouer',
      modes: 'Six façons de jouer',
      faq: 'Questions fréquentes',
      more: 'Pour aller plus loin',
    },
    links: {
      rules: 'Lire les règles complètes et le barème des points',
      modes: 'Comparer les modes en détail',
    },
  },
  howToPlay: HOW_TO_PLAY,
  modes: MODES,
  modeTable: MODE_TABLE,
  modeTableHeadings: ['Mode', 'Joueurs', 'Durée'],
  premium: MODES_PREMIUM,
  blog: ARTICLES,
  ui: {
    atAGlance: 'En un coup d’œil',
    allArticles: 'Tous les articles',
    theRules: 'Les règles du jeu',
    theModes: 'Les modes de jeu',
  },
};
